import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "certificate-paper" }
const _hoisted_2 = { class: "certificate-number" }
const _hoisted_3 = { class: "certificate-foot" }
const _hoisted_4 = { class: "certificate-generated-at" }
const _hoisted_5 = { class: "certificate-dialog-actions" }

import { PilotAssessmentCertificate } from '@/service'
import { downloadPilotAssessmentCertificate } from '@/utils/downloadPilotAssessmentCertificate'
import { CandidateButton, CandidateDialog } from './ui/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificateDialog',
  props: {
    modelValue: { type: Boolean },
    certificate: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function formatScore(score: number | string): string {
  const value = Number(score)
  return Number.isFinite(value) ? value.toFixed(1) : String(score)
}

function downloadCertificate() {
  downloadPilotAssessmentCertificate(props.certificate)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CandidateDialog), {
    class: "candidate-certificate-dialog",
    "model-value": _ctx.modelValue,
    width: "960px",
    "show-close": false,
    "close-on-click-modal": false,
    "align-center": "",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("h2", null, "专业技能证书", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "certificate-en" }, "UAV PILOT PROFESSIONAL SKILL CERTIFICATE", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "certificate-title" }, "无人机飞手专业能力考评", -1)),
        _createElementVNode("p", null, [
          _createTextVNode(" 已完成“" + _toDisplayString(_ctx.certificate.sessionName) + "”本轮全部启用考试科目", 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _cache[3] || (_cache[3] = _createTextVNode(" 各科目成绩及总分达到专业技能证书生成条件 "))
        ]),
        _createElementVNode("div", _hoisted_2, "证书编号：" + _toDisplayString(_ctx.certificate.certificateNo), 1),
        _createElementVNode("div", _hoisted_3, " 第 " + _toDisplayString(_ctx.certificate.roundNo) + " 次考试 · 总分 " + _toDisplayString(formatScore(_ctx.certificate.totalScore)) + " · " + _toDisplayString(_ctx.certificate.completedDate), 1),
        _createElementVNode("div", _hoisted_4, "生成时间：" + _toDisplayString(_ctx.certificate.generatedAt), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(CandidateButton), {
          variant: "outline",
          tone: "default",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" 关闭 ")
          ])),
          _: 1
        }),
        _createVNode(_unref(CandidateButton), {
          variant: "solid",
          tone: "primary",
          onClick: downloadCertificate
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" 下载证书图片 ")
          ])),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})